var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 .75c7.525 0 14.337 3.05 19.269 7.981A27.165 27.165 0 0 1 55.25 28c0 7.525-3.05 14.337-7.981 19.269A27.165 27.165 0 0 1 28 55.25a27.165 27.165 0 0 1-19.269-7.981A27.165 27.165 0 0 1 .75 28c0-7.525 3.05-14.337 7.981-19.269A27.165 27.165 0 0 1 28 .75z",
    stroke: "#272726",
    strokeWidth: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.624 18c-1.302 0-2.496.408-3.549 1.215-1.009.774-1.68 1.759-2.076 2.475-.396-.716-1.068-1.701-2.077-2.475C24.87 18.408 23.675 18 22.372 18c-3.634 0-6.375 2.947-6.375 6.854 0 4.221 3.42 7.11 8.597 11.482.879.742 1.875 1.584 2.91 2.481a.753.753 0 0 0 .988 0c1.036-.897 2.033-1.739 2.912-2.482C36.581 31.963 40 29.074 40 24.854c0-3.908-2.74-6.855-6.376-6.855z",
    stroke: "#CB2127",
    strokeWidth: 1.8,
    fill: "#CB2127"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeYes);
export default __webpack_public_path__ + "static/media/like-yes.7716172fce0a1261544da14f41632f48.svg";
export { ForwardRef as ReactComponent };